import Header from '../Header';
import React from 'react';

import DataProvider from '../DataProvider';
import UserProvider from '../UserProvider';

import styled from 'styled-components';

function App() {
  return (
    // <UserProvider>
    <DataProvider>
      <Wrapper>
        <Header />
      </Wrapper>
    </DataProvider>
    // </UserProvider>
  );
}

export default App;

const Wrapper = styled.div`
  background-color: var(--global-bg-color);
  min-height: 100%;
`;
